import React from "react"

const ProfileStats = ({ name, value, color }) => {
  return (
    <div className="stats-container">
      <div
        className="count"
        style={{
          color: color,
        }}
      >
        {value}
      </div>
      <div className="name">{name}</div>
    </div>
  )
}

export default ProfileStats
